/**
 * Domain-agnostic SDK wrappers for the custom-workflows endpoints.
 *
 * Lifted from `features/custom-workflows/api/customWorkflows.api.ts` so any
 * surface that needs custom-workflow data (the chats `ImageGenerationOptions`,
 * the `CustomWorkflowInlineInput` entity component, etc.) can consume them
 * without crossing into the `custom-workflows` feature slice.
 *
 * The original feature path re-exports these symbols for backward
 * compatibility — existing consumers keep working unchanged.
 */
import { inferenceHttp } from '@/lib/api/inference-client';
import {
  CustomWorkflowsService,
  ListCustomWorkflowsResponseDto,
  CustomWorkflowWithFieldsDto,
} from '@inference.engine/api-client/web';
import { logger } from '@/lib/utils/logger';

export const listCustomWorkflows = async (
  workspaceId: string,
): Promise<ListCustomWorkflowsResponseDto> => {
  try {
    const response = await CustomWorkflowsService.list({
      client: inferenceHttp,
      query: { workspaceId },
    });
    return response.data ?? { data: [], total: 0 };
  } catch (error) {
    logger.error('Failed to list custom workflows:', error);
    return { data: [], total: 0 };
  }
};

export const getCustomWorkflowById = async (
  id: string,
): Promise<CustomWorkflowWithFieldsDto | null> => {
  try {
    const response = await CustomWorkflowsService.getByIdWithFields({
      client: inferenceHttp,
      path: { id },
    });
    return response.data ?? null;
  } catch (error) {
    logger.error('Failed to get custom workflow by id:', error);
    return null;
  }
};
